import { useState } from 'react';
import { recordLeadRegistration } from '../api';

export default function RegistrationModal({ leadId, onClose, onRecorded }: {
  leadId: string; onClose: () => void; onRecorded: () => Promise<void>;
}) {
  const [center, setCenter] = useState('');
  const [reference, setReference] = useState('');
  const [date, setDate] = useState(new Date(Date.now() + 330 * 60_000).toISOString().slice(0, 10));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function save() {
    setBusy(true); setError('');
    try {
      await recordLeadRegistration(leadId, { center, reference: reference.trim(), registered_on: date });
      await onRecorded();
      onClose();
    } catch (error) {
      let message = 'Registration could not be recorded. Your entries are kept; please try again.';
      const response = error instanceof Error ? error.message.match(/^4\d\d\s+(\{.*\})$/s) : null;
      if (response) {
        try {
          const body = JSON.parse(response[1]);
          if (typeof body.error === 'string') message = body.error;
        } catch { /* Keep the plain-language retry message. */ }
      }
      setError(message);
    }
    finally { setBusy(false); }
  }
  return <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/50 p-3 sm:items-center" role="dialog" aria-modal="true" aria-labelledby="registration-title">
    <form onSubmit={(event) => { event.preventDefault(); void save(); }} className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl">
      <h3 id="registration-title" className="text-base font-semibold text-slate-900">Record registration · Won</h3>
      <p className="mt-1 text-xs text-slate-500">Optional manual recording after checking the ERP or clinic registration record. An appointment alone is not a registration.</p>
      <label className="mt-4 block text-sm">Centre<select required value={center} onChange={(event) => setCenter(event.target.value)} disabled={busy} className="mt-1 w-full rounded-lg border p-2"><option value="">Select centre</option>{['BBSR', 'BAM', 'Angule'].map((value) => <option key={value}>{value}</option>)}</select></label>
      <label className="mt-3 block text-sm">Registration reference<input required maxLength={100} value={reference} onChange={(event) => setReference(event.target.value)} disabled={busy} className="mt-1 w-full rounded-lg border p-2" /></label>
      <label className="mt-3 block text-sm">Registration date<input required type="date" value={date} onChange={(event) => setDate(event.target.value)} disabled={busy} className="mt-1 w-full rounded-lg border p-2" /></label>
      {error && <p role="alert" className="mt-3 text-sm text-rose-700">{error}</p>}
      <div className="mt-4 flex justify-end gap-3"><button type="button" onClick={onClose} disabled={busy} className="rounded-lg px-3 py-2 text-sm">Cancel</button><button disabled={busy || !reference.trim() || !center || !date} className="rounded-lg bg-emerald-600 px-3 py-2 text-sm text-white disabled:opacity-50">{busy ? 'Recording…' : 'Record registration'}</button></div>
    </form>
  </div>;
}
